export enum ReportType {
    Pie = "Pie",
    Bar = "Bar"
}